/** @jsxImportSource @emotion/react */

import React, { FC, useEffect, useMemo, useState } from 'react';

import legendStyles from './legend.styles';
import { useMediaQuery } from '@mui/material';
import PredefinedSwipableDrawer from '../swipable-edge-drawer/swipable-drawer.component';
import legend from '../../assets/legend.svg';
import { useIntl } from 'react-intl';
import { Z_INDEX } from '../../constants/zIndex';

export const Legend: FC = () => {
    const isDesktop = useMediaQuery('(min-width:600px)');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const intl = useIntl();
    useEffect(() => {
        const overlayClickHandler = (e: MouseEvent) => {
            if (
                (modalIsOpen && !(e.target instanceof Element)) ||
                !(e.target as Element).closest('#legendButton')
            ) {
                setModalIsOpen(false);
            }
        };

        document.addEventListener('click', overlayClickHandler);

        return () => {
            document.removeEventListener('click', overlayClickHandler);
        };
    }, []);

    const content = useMemo(() => {
        return (
            <div>
                <div css={legendStyles.menuHeader}>{intl.formatMessage({ id: 'legend' })}</div>
                <img css={legendStyles.legendImage} src={legend} alt="Legend" />
            </div>
        );
    }, []);

    return (
        <>
            <div id="legendButton" onClick={() => setModalIsOpen(true)} css={legendStyles.legend}>
                ?
                {isDesktop ? (
                    <>
                        {modalIsOpen && (
                            <div css={[legendStyles.menuList, legendStyles.menuListDesktop]}>
                                {content}
                            </div>
                        )}
                    </>
                ) : (
                    <PredefinedSwipableDrawer
                        onClose={() => setModalIsOpen(false)}
                        onOpen={() => setModalIsOpen(true)}
                        isOpen={modalIsOpen}
                        snapPoints={[0.5]}
                        zIndex={Z_INDEX.DRAWER_LEGEND}>
                        <div css={[legendStyles.menuList]}>{content}</div>
                    </PredefinedSwipableDrawer>
                )}
            </div>
        </>
    );
};
